import { useMedia } from "use-media";
import { media } from "@nju/css";
import {
  IMobileOrchestrator,
  IMobileReactivationOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { PaymentState } from "@nju/data-access-portal-payment";
import { IScope } from "@nju/scope";
import { SideBox } from "@nju/ui";
import { SidebarMobilePaymentDetails } from "./partials";

interface ISidebarMobilePaymentProps {
  userId: string | undefined;
  paymentState?: PaymentState;
  state?: IMobileOrchestrator["state"] | "REACTIVATION";
  orchestrator:
    | IMobileOrchestrator
    | IMobileReactivationOrchestrator
    | undefined;
  isPending: boolean;
  variant: IScope;
}

export function SidebarMobilePayment({
  state,
  paymentState,
  orchestrator,
  isPending,
  variant,
  userId,
}: ISidebarMobilePaymentProps) {
  const isMobile = useMedia(media.onlyMobile);

  if (!orchestrator) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const { orderSummary } = orchestrator;

  if (orderSummary === undefined) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      {isMobile && (
        <SideBox
          isExpandable={true}
          isExpanded={false}
          testId="mobile-payments-box"
          title="opłaty"
        >
          {({ isExpanded }) => {
            return (
              isExpanded && (
                <SidebarMobilePaymentDetails
                  isPending={isPending}
                  orderSummary={orderSummary}
                  paymentState={paymentState}
                  state={state}
                  userId={userId}
                  variant={variant}
                />
              )
            );
          }}
        </SideBox>
      )}
      {!isMobile && (
        <>
          <SideBox
            isExpandable={false}
            testId="mobile-payments-box"
            title="opłaty"
          >
            <SidebarMobilePaymentDetails
              isPending={isPending}
              orderSummary={orderSummary}
              paymentState={paymentState}
              state={state}
              userId={userId}
              variant={variant}
            />
          </SideBox>
        </>
      )}
    </>
  );
}
